import { render, staticRenderFns } from "./disable-usage-options.vue?vue&type=template&id=9b4d567e&scoped=true&"
import script from "./disable-usage-options.vue?vue&type=script&lang=js&"
export * from "./disable-usage-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4d567e",
  null
  
)

export default component.exports